import { IPersonalInfoCmsMobile } from '@vfit/consumer/data-access';

export const organizeConfirmIdentityCard = (dataFromCms: IPersonalInfoCmsMobile) => ({
  titleCms: dataFromCms?.personalinfomobile?.clientRecognition?.title || '',
  descriptionCms: dataFromCms?.personalinfomobile?.clientRecognition?.description || '',
  placeholderCms: dataFromCms?.personalinfomobile?.selectInput?.contactPlaceholder || '',
  ctaLabelCms: dataFromCms?.personalinfomobile?.clientRecognition?.codeNotAccessLabel || '',
  ctaUrl: dataFromCms?.personalinfomobile?.clientRecognition?.codeNotAccessUrl || '',
});
